import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconMathGreaterThanCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconMathGreaterThanCircle"><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><Path d="M9.25 8.75L15.75 12L9.25 15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconMathGreaterThanCircle;
